export enum ExtraDataMappingType {
  // Errors
  NoEmptyValueNoDefault = "no-empty-value-no-default",
  NotAllMappingsUsed = "not-all-mappings-used",
  InputWithNoMapping = "input-with-no-mapping",
  QuantityOutOfRange = "quantity-out-of-range",
  LowConfidenceInput = "low-confidence-input",
  UnitNotMatching = "unit-not-matching",
  NoUnit = "no-unit",
  NoQuantity = "no-quantity",

  // Modifiers
  QuantityModifier = "quantity-modifier",
}
